import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { IncDataSrcEnumSelect } from './IncDataSrcEnumSelect';

// Date and cutoff basis options depend on the selected transaction source
export const IncDataSrcForm = (formProps) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [fieldToTrxSrcCodeToEnumSpecs, setFieldToTrxSrcCodeToEnumSpecs] = useState();

  useEffect(() => {
    rsrc.data(module, 'INC_DATA_SRC_ENUM_OPTIONS_DATA_PLUGIN').then(setFieldToTrxSrcCodeToEnumSpecs);
  }, []);

  if (!fieldToTrxSrcCodeToEnumSpecs) {
    return null;
  }

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.dateBasis.component = (
      <IncDataSrcEnumSelect
        key="dateBasis"
        fieldDef={fieldToFieldDef.dateBasis}
        trxSrcCodeToEnumSpecs={fieldToTrxSrcCodeToEnumSpecs.dateBasis}
      />
    );
    fieldToFieldDef.cutoffBasis.component = (
      <IncDataSrcEnumSelect
        key="cutoffBasis"
        fieldDef={fieldToFieldDef.cutoffBasis}
        trxSrcCodeToEnumSpecs={fieldToTrxSrcCodeToEnumSpecs.cutoffBasis}
      />
    );
  };

  return <EntityForm augFieldDefs={augFieldDefs} {...formProps} />;
};
